module.exports = __webpack_public_path__ + "img/house2b.9fec05f3.jpg";